export const carSearchType = {
  AIRPORT: 'Airport',
  CITY: 'City',
};

export const searchTypesEnum = {
  AIR: 'air',
  CAR: 'car',
  HOTEL: 'hotel',
  RAIL: 'rail',
};

// TODO: Check if we dont need more user types
export const userTypes = {
  OWNER: 'owner',
  VISITOR: 'visitor',
  GUEST: 'guest',
};

export const triphubTabs = {
  TRIP: 'trip',
  EVENT: 'event',
  GROUP: 'group',
  ADD_REVIEW: 'add_review',
  REVIEWS: 'reviews',
};

export const submitLabelsVisitor = {
  [triphubTabs.TRIP]: 'JoinTrip',
  [triphubTabs.EVENT]: 'JoinEvent',
  [triphubTabs.GROUP]: 'JoinDiscussion',
};

export const submitLabelsGuest = {
  [triphubTabs.TRIP]: 'ViewInvoice',
  [triphubTabs.EVENT]: 'AddMeeting',
  [triphubTabs.GROUP]: 'InviteTravelers',
};

export const submitLabelsOwner = {
  [triphubTabs.TRIP]: 'ViewInvoice',
  [triphubTabs.EVENT]: 'AddMeeting',
  [triphubTabs.GROUP]: 'InviteTravelers',
};

export const labelByUsers = {
  [userTypes.OWNER]: submitLabelsOwner,
  [userTypes.GUEST]: submitLabelsGuest,
  [userTypes.VISITOR]: submitLabelsVisitor,
};

export const subSearchTypeEnum = {
  oneWay: 'oneway',
  roundTrip: 'roundtrip',
  multiCity: 'multicity',
};

export const passengerTitles = {
  TITLE: 'Title',
  MR: 'Mr',
  MRS: 'Mrs',
  MS: 'Ms',
  MISS: 'Miss',
  MSTR: 'Mstr',
  MILE: 'Mile',
  DR: 'Dr',
  SIR: 'Sir',
  FATHER: 'Father',
  SISTER: 'Sister',
  BROTHER: 'Brother',
  LT: 'Lt',
  CAPT: 'Capt',
  PROF: 'Prof',
  DUKE: 'Duke',
  CONGRESSMAN: 'Congressman',
  DUCHESS: 'Duchess',
  REV: 'Rev',
  RT_HON: 'Rt Hon',
  ST: 'St',
};

export const companyEmails = {
  info: 'info@its.com',
  copyright: 'exp-copyright@its.com',
  support: 'support@its.com',
  protectionOfficer: 'DataProtectionOfficer@its.com',
  protectionOfficerLC: 'dataprotectionofficer@its.com',
  privacy: 'privacy@its.com',
  privacyOfficer: 'PrivacyOfficer@its.com',
  gdpRepresentative: 'its@gdprrepresentative.eu',
  privayrep: 'its@privacyrep.co.uk',
};

export const companyLinks = {
  contactDataProtection: 'https://www.its.com/form/dataprotection/contactDataProtection.aspx',
  reportFraud: 'https://reportfraud.ftc.gov/',
};

export const AAServiceTypes = {
  LEISURE: { text: 'Leisure', underText: 'Book Your Leisure Trip', keyword: 'leisure' },
  CORPORATE_TRAVEL: {
    text: 'Corporate Travel',
    underText: 'Book Your Business Trip And Save',
    keyword: 'corporate',
  },
  BUSINESS_EXTRA: {
    text: 'Business Extra',
    underText: 'Book Your Business Extra Trip',
    keyword: 'businessextra',
  },
  //SHUTTLE: { text: 'Shuttle', underText: 'Book Your Shuttle Flight', keyword: 'shuttle' },
};

export const searchSubTypeToAirRequestTypeMap = {
  oneway: 1,
  roundtrip: 2,
  multicity: 3,
};

export const customUDIDEntryTypes = {
  TEXT_ENTRY: 'TextEntry',
  PULL_DOWN: 'PullDown',
  PULL_DOWN_WITH_CONDITIONAL_QUESTIONS: 'PullDownWithConditionalQuestions',
};

export const customFieldDataTypes = {
  ALPHABET: 'Alphabet',
  ALPHA_NUMERIC: 'AlphaNumeric',
  NUMERIC: 'Numeric',
  EMAIL: 'Email',
  ALPHA_NUMERIC_WITH_SPACE: 'AlphaNumericWithSpace',
  ALPHA_NUMERIC_WITH_SPECIAL_CHAR: 'AlphaNumericWithSpecialChar',
  DATE_TIME: 'DateTime',
};
export const GDS = {
  SABRE: 'Sabre',
  NDC: 'NDC',
};
export const AirLegs = {
  FIRST_LEG: 1,
  SECOND_LEG: 2,
};
export const MULTIPLE_AIRLINE = 'MultipleAirline';

export const Source = {
  ANDROID: 'android',
  IOS: 'ios',
  MSITE: 'web',
};

export const PassengerVendorCode = {
  AIR: 'AirLineCode',
  HOTEL: 'HotelChainCode',
  CAR: 'CarVendorCode',
};

export const PROGRAM_NUMBER = {
  AIR: 'ProgramNo',
  OTHERS: 'ProgramNumber',
};

export const ComponentChars = {
  AIR: 'A',
  CAR: 'C',
  HOTEL: 'H',
};

export const tripsFilter = {
  PENDING: 'Pending',
  UPCOMING_PURCHASE: 'Purchased',
  PAST: 'Past',
  CANCELED: 'Canceled',
  APPROVED: 'Approved',
  PENDING_CANCEL: 'PendingCancel',
  PENDING_APPROVAL: 'PendingApproval',
  PENDING_CREDIT_CARD: 'PendingCreditCardIssue',
  TRAVELED: 'Traveled',
};

export const GdsSource = {
  NDC: 26,
  SabreNDC: 29,
};

export const virtualPaymentType = {
  None: 0,
  ConfermaSabreVP: 1,
  ConnexPayAPIVP: 2,
  ConfermaAPIVP: 3,
};

export const creditCardType = {
  VISA: 'VISA',
  MASTERCARD: 'MASTERCARD',
};

export const HotelReviewApiActions = {
  CREATE: 'create',
  GET_REVIEW: 'getReview',
  UPDATE: 'update',
};
export const expenseActions = {
  GET_ALL_REPORTS: 'getAllReportsOfUser',
  PENDING: 'Pending',
  CREATE: 'create',
  GET_REPORTS_AND_EXPENSES: 'getReportsAndExpenses',
  DELETE_EXPENSE: 'deleteReport',
  UPDATE_EXPENSE_REPORT_NAME: 'updateReportName',
  UPDATE_REPORT: 'updateReport',
  GET_RECEIPTS_OF_USER: 'getReceiptsOfUser',
  MOVE_EXPENSE: 'moveExpense',
  UPDATE_STATUS_REPORT: 'updateStatusReport',
  UPDATE_EXPENSE: 'updateExpense',
  DELETE_RECEIPT_FROM_USER: 'deleteReceiptFromUser',
  EXPENSE_DELETE: 'deleteExpense',
};

export const chargeActions = {
  GET_CHARGES: 'getCharges',
  SET_CHARGE_AS_PERSONAL: 'setChargeAsPersonal',
  SET_CHARGE_IN_USE_FOR_EXPENSE: 'setChargeInUseForExpense',
};

export const appType = {
  TRAVEL: 0,
  EXPENSE: 1,
  EVENT: 2,
};
export const COMPONENT_TYPES = {
  AIR: 1,
  AIR_EXTRA: 2,
  HOTEL: 3,
  CAR: 4,
  RAIL: 5,
};

export const stationValues = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK' },
  { name: 'American Samoa', abbreviation: 'AS' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'District Of Columbia', abbreviation: 'DC' },
  { name: 'Federated States Of Micronesia', abbreviation: 'FM' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Guam', abbreviation: 'GU' },
  { name: 'Hawaii', abbreviation: 'HI' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Marshall Islands', abbreviation: 'MH' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Northern Mariana Islands', abbreviation: 'MP' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Palau', abbreviation: 'PW' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Puerto Rico', abbreviation: 'PR' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virgin Islands', abbreviation: 'VI' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
];

export const REPORT_STATUS = {
  PENDING: 'Pending',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  DENIED: 'Denied',
};

export const LOST_RECEIPT_OPTION = { id: -1, label: 'Lost Receipt', icon: 'search' };
export const PHOTO_LIBRARY_OPTION = { id: 1, label: 'Photo Library', icon: 'image' };
export const TAKE_PHOTO_OPTION = { id: 2, label: 'Take Photo', icon: 'camera' };
export const CHOOSE_FILES_OPTION = { id: 3, label: 'Choose Files', icon: 'file' };
export const PHOTO_UPLOADS = { id: 4, label: 'Photo Uploads', icon: 'share' };

export const DEFAULT_BILLABLE_OPTION = { label: '--Select--', value: '0' };
export const BILLABLE_OPTIONS = {
  default: DEFAULT_BILLABLE_OPTION,
  billable: {
    label: 'Billable',
    value: 'BILLABLE',
  },
  nonBillable: {
    label: 'Non-Billable',
    value: 'NON_BILLABLE',
  },
};

export const expenseInputTypes = {
  ...customUDIDEntryTypes,
  MONEY: 'Money',
  AUTO_COMPLETE: 'AutoComplete',
  PARTICIPANT: 'Participant',
  PAYMENT_TYPE: 'PaymentType',
};

export const EXPENSE_FORM_KEYS = {
  STEP_ONE: 'STEP_ONE',
  STEP_TWO: 'STEP_TWO',
};

export const EXPENSE_ACTION_TYPES = {
  CREATION: 'creation',
  UPDATE: 'update',
};

export const EXPENSE_SUB_TAB_OPTIONS = {
  RECEIPTS: 'RECEIPTS',
  CHARGES: 'CHARGES',
  MILEAGE: 'MILEAGE',
  MANUAL: 'MANUAL',
  ANY: 'ANY', // Required for the expense edit/update mode
};

export const EXPENSE_RECEIPTS_SUB_TAB_OPTIONS = {
  CAMERA: 'CAMERA',
  UPLOADS: 'UPLOADS',
  EMAIL: 'EMAIL',
};

export const EXPENSE_MAPPED_INFO_FIELD_KEYS = {
  RECEIPTS_VAULT: 'mappedInfoFields',
  UPLOADED_RECEIPT: 'ExpenseInfoFieldsMapped',
};
